import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/icon-globe.svg")